(function () {
  const root = document.querySelector('[data-quiz]');
  if (!root) return;

  // =========================
  // 1) QUIZ DATA (final order)
  // - key: stable option id (for analytics & result logic)
  // - score: ONLY for Q1-Q4
  // - meta: for Q5/Q6 (no scoring, but keep for later narrative)
  // =========================

  const QUIZ = [
    {
      id: "q1",
      text: "How have you been feeling lately?",
      hint: "There’s no need to overthink this — just notice what feels familiar.",
      scoreable: true,
      options: [
        { key: "overwhelmed_mind", label: "A bit overwhelmed — like my mind never really rests", score: { e: 1 } },
        { key: "sensitive_affected", label: "Emotionally sensitive, easily affected by people or situations", score: { w: 1, m: 1 } },
        { key: "tired_numb", label: "Tired or a little numb, even when things seem “fine”", score: { f: 1 } },
        { key: "restless_change", label: "Restless — wanting change but not knowing where to begin", score: { wd: 1 } },
        { key: "ok_off", label: "Mostly okay, but something feels slightly off", score: { e: 1 } }
      ]
    },

    // Q2 = (old Q3)
    {
      id: "q2",
      text: "Lately, what’s been hardest to manage?",
      hint: "Let’s gently name what’s been weighing on you the most.",
      scoreable: true,
      options: [
        { key: "overthinking_slowdown", label: "Overthinking or anxious thoughts that won’t slow down", score: { e: 1 } },
        { key: "emotional_upsdowns", label: "Emotional ups and downs, or feeling things very deeply", score: { w: 1 } },
        { key: "low_energy_stuck", label: "Low energy, procrastination, or feeling stuck", score: { f: 1, wd: 1 } },
        { key: "unsupported_taken", label: "Feeling unsupported or taken for granted", score: { w: 1, e: 1 } },
        { key: "boundaries_yes", label: "Setting boundaries — saying yes when I want to say no", score: { m: 1 } }
      ]
    },

    // Q3 = (old Q4) - coping pattern
    {
      id: "q3",
      text: "When you’re under stress, what do you usually do?",
      hint: "This isn’t about judging — it’s just noticing how you’ve been getting through.",
      scoreable: true,
      options: [
        { key: "withdraw_space", label: "I tend to withdraw and go quiet, needing space", score: { w: 1 } },
        { key: "push_through_fine", label: "I push through and act like I’m fine, even when I’m not", score: { f: 1 } },
        { key: "control_safe", label: "I try to stay in control so I can feel safe", score: { e: 1 } },
        { key: "distract_avoid", label: "I distract myself to avoid sitting with it", score: { wd: 1 } },
        { key: "reassurance_alone", label: "I reach out for reassurance, but still feel alone", score: { m: 1, w: 1 } }
      ]
    },

    // Q4 = (old Q2) - longing / nourishing
    {
      id: "q4",
      text: "If that part of life felt a little lighter, what would you long for most?",
      hint: "You don’t have to decide or explain — just notice what you’re drawn to.",
      scoreable: true,
      options: [
        { key: "long_calm_body", label: "Feeling calm and steady — more at home in my body", score: { w: 1, e: 1 } },
        { key: "long_warm_connection", label: "Feeling warmth and connection — more open with others", score: { f: 1 } },
        { key: "long_clarity_matter", label: "Feeling clear — knowing what truly matters right now", score: { m: 1, wd: 1 } },
        { key: "long_capable_forward", label: "Feeling capable again — like I can move forward", score: { wd: 1, f: 1 } },
        { key: "long_less_pressure", label: "Feeling less pressure — more space to just be", score: { e: 1, w: 1 } }
      ]
    },

    // Q5 (no scoring) - support preference (bridge to product)
    {
      id: "q5",
      text: "When things feel like a bit much, what kind of presence helps you most?",
      hint: "This isn’t about fixing anything — just noticing what feels easiest to receive.",
      scoreable: false,
      options: [
        { key: "support_reminder", label: "Something gentle I can return to — a quiet reminder" },
        { key: "support_ritual", label: "A small ritual that helps me reset" },
        { key: "support_safety", label: "A sense of emotional safety — feeling held, not rushed" },
        { key: "support_courage", label: "A soft boost of courage when I hesitate" },
        { key: "support_balance", label: "Something that helps me feel more balanced inside" }
      ]
    },

    // Q6 (no scoring) - affirmation
    {
      id: "q6",
      text: "Which affirmation feels most true for you today?",
      hint: "Take a breath. Which one feels like it’s speaking to you?",
      scoreable: false,
      options: [
        { key: "aff_carry_alone", label: "I don’t have to carry everything alone." },
        { key: "aff_safe_slow", label: "It’s safe for me to slow down." },
        { key: "aff_feelings_valid", label: "My feelings are valid — I can let them move through." },
        { key: "aff_next_step", label: "I trust myself to take the next step." },
        { key: "aff_choose_self", label: "I’m allowed to choose myself without guilt." }
      ]
    }
  ];

  // =========================
  // 2) Elements
  // =========================
  const screens = {
    intro: root.querySelector('[data-screen="intro"]'),
    quiz: root.querySelector('[data-screen="quiz"]'),
    loading: root.querySelector('[data-screen="loading"]')
  };

  const btnStart = root.querySelector('[data-start]');
  const btnBack = root.querySelector('[data-back]');
  const qText = root.querySelector('[data-qtext]');
  const qHint = root.querySelector('[data-qhint]');
  const optionsWrap = root.querySelector('[data-options]');
  const progressWrap = root.querySelector('[data-progress]');
  const card = root.querySelector('[data-card]');

  // =========================
  // 3) State
  // =========================
  let idx = 0;
  const answers = {}; // { q1: "key", q2: "key"... }

  // =========================
  // 4) Helpers
  // =========================
  function setActiveScreen(name) {
    Object.keys(screens).forEach(k => {
      const el = screens[k];
      if (!el) return;
      const active = (k === name);
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
  }

  function renderProgress() {
    if (!progressWrap) return;
    progressWrap.innerHTML = "";
    for (let i = 0; i < QUIZ.length; i++) {
      const dot = document.createElement('span');
      dot.className = "vq-dot" + (i < idx ? " is-done" : "");
      progressWrap.appendChild(dot);
    }
  }

  function renderQuestion() {
    const q = QUIZ[idx];
    qText.textContent = q.text;
    qHint.textContent = q.hint || "Choose what feels true.";

    // back enabled only if idx > 0
    btnBack.classList.toggle('is-disabled', idx === 0);

    optionsWrap.innerHTML = "";
    q.options.forEach((opt) => {
      const btn = document.createElement('button');
      btn.type = "button";
      btn.className = "vq-option";
      btn.textContent = opt.label;

      if (answers[q.id] === opt.key) btn.classList.add('is-selected');

      btn.addEventListener('click', () => {
        answers[q.id] = opt.key;

        [...optionsWrap.querySelectorAll('.vq-option')].forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        window.clearTimeout(window.__vqTimer);
        window.__vqTimer = window.setTimeout(() => goNext(), 380);
      });

      optionsWrap.appendChild(btn);
    });

    renderProgress();
  }

  function fadeTransition(nextFn) {
    if (!card) { nextFn(); return; }
    card.classList.remove('vq-fade-in');
    card.classList.add('vq-fade-out');

    window.setTimeout(() => {
      nextFn();
      card.classList.remove('vq-fade-out');
      card.classList.add('vq-fade-in');
    }, 160);
  }

  function goNext() {
    if (idx < QUIZ.length - 1) {
      fadeTransition(() => {
        idx += 1;
        renderQuestion();
      });
      return;
    }
    finishQuiz();
  }

  function goBack() {
    if (idx === 0) return;
    window.clearTimeout(window.__vqTimer);
    fadeTransition(() => {
      idx -= 1;
      renderQuestion();
    });
  }

  // =========================
  // 5) Scoring (Q1-Q4 only)
  // =========================
  function computeScores() {
    // score keys: w (water), f (fire), e (earth), wd (wood), m (metal)
    const totals = { w: 0, f: 0, e: 0, wd: 0, m: 0 };

    QUIZ.forEach((q) => {
      if (!q.scoreable) return;
      const pickedKey = answers[q.id];
      if (!pickedKey) return;
      const opt = q.options.find(o => o.key === pickedKey);
      if (!opt || !opt.score) return;

      Object.keys(opt.score).forEach(k => {
        totals[k] = (totals[k] || 0) + Number(opt.score[k] || 0);
      });
    });

    return totals;
  }

  function finishQuiz() {
    setActiveScreen('loading');

    const scores = computeScores();

    // Build URL params (stable + compact)
    const params = new URLSearchParams();

    // raw answers
    QUIZ.forEach(q => {
      const k = answers[q.id];
      if (k) params.set(q.id, k);
    });

    // scores
    params.set('w', String(scores.w));
    params.set('f', String(scores.f));
    params.set('e', String(scores.e));
    params.set('wd', String(scores.wd));
    params.set('m', String(scores.m));

    // you can also include a schema version
    params.set('v', '1');

    const resultPath = "/pages/energy-result"; // update if needed
    const url = resultPath + "?" + params.toString();

    setTimeout(() => {
      window.location.href = url;
    }, 550);
  }

  // =========================
  // 6) Events + Init
  // =========================
  if (btnStart) {
    btnStart.addEventListener('click', () => {
      setActiveScreen('quiz');
      idx = 0;
      renderQuestion();
      card && card.classList.add('vq-fade-in');
    });
  }

  if (btnBack) btnBack.addEventListener('click', goBack);

  setActiveScreen('intro');
})();
